export const BlogDetails = [
  {
    title: "The useEffect(a React hook) story",
    desc: "Understanding parts of useEffect hook",
    link: "https://medium.com/@roypartha0512/destructuring-useeffect-a-react-hook-bb20d0b09622",
  },
  {
    title: "React “Behind the scenes”",
    desc: "Discussing few core React concepts",
    link: "https://medium.com/@roypartha0512/react-behind-the-scenes-84f46cc10fff",
  },
  {
    title: "Material UI vs Tailwind CSS",
    desc: "Brief, Pros and Cons of these frameworks",
    link: "https://medium.com/@roypartha0512/material-ui-vs-tailwind-css-32a508a9ab6a",
  },
];
